export default function SuccessTickCircleIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M22.4974 40.3332C32.6226 40.3332 40.8307 32.1251 40.8307 21.9998C40.8307 11.8746 32.6226 3.6665 22.4974 3.6665C12.3722 3.6665 4.16406 11.8746 4.16406 21.9998C4.16406 32.1251 12.3722 40.3332 22.4974 40.3332Z'
        fill='#A0383F'
      />
      <path
        id='Vector_2'
        d='M19.8947 28.5633C19.528 28.5633 19.1797 28.4166 18.923 28.1599L13.7347 22.9716C13.203 22.4399 13.203 21.5599 13.7347 21.0283C14.2664 20.4966 15.1464 20.4966 15.678 21.0283L19.8947 25.2449L29.318 15.8216C29.8497 15.2899 30.7297 15.2899 31.2614 15.8216C31.793 16.3533 31.793 17.2333 31.2614 17.7649L20.8664 28.1599C20.6097 28.4166 20.2614 28.5633 19.8947 28.5633Z'
        fill='white'
      />
    </>
  );
}
